<div class="order-container">
  <h2>Purchase Orders</h2>
  
  <div class="actions-section">
    <button mat-raised-button class="create-btn" (click)="createNewOrder()">
      <mat-icon>add</mat-icon>
      Create New Purchase Order
    </button>
  </div>
  
  <div class="order-content">
    <div *ngIf="loading" class="loading-message">
      <p>Loading purchase orders...</p>
    </div>

    <div *ngIf="error" class="error-message">
      <p>{{ error }}</p>
      <button mat-raised-button color="primary" (click)="loadPurchaseOrders()">Retry</button>
    </div>

    <div *ngIf="!loading && !error" class="table-container">
      <!-- Search Filter -->
      <mat-form-field class="filter-field">
        <mat-label>Search purchase orders</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Search by order number, vendor..." #input>
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>

      <!-- Purchase Orders Table -->
      <table mat-table [dataSource]="dataSource" matSort class="order-table">
        
        <!-- Number Column -->
        <ng-container matColumnDef="number">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Order Number</th>
          <td mat-cell *matCellDef="let order">{{ order.number || '-' }}</td>
        </ng-container>

        <!-- Date Column -->
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Order Date</th>
          <td mat-cell *matCellDef="let order">{{ (order.date | date:'MM/dd/yyyy') || '-' }}</td>
        </ng-container>

        <!-- Vendor Name Column -->
        <ng-container matColumnDef="vendorName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Vendor</th>
          <td mat-cell *matCellDef="let order">{{ order.vendorName || '-' }}</td>
        </ng-container>

        <!-- Status Column -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
          <td mat-cell *matCellDef="let order">
            <span class="status-badge" [class.status-active]="order.status === 'Active'">
              {{ (order.status || 'Draft') | humanizeEnum }}
            </span>
          </td>
        </ng-container>

        <!-- Total Amount Column -->
        <ng-container matColumnDef="totalAmount">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Total</th>
          <td mat-cell *matCellDef="let order">{{ order.totalAmount | currency }}</td>
        </ng-container>

        <!-- Copy Column -->
        <ng-container matColumnDef="copy">
          <th mat-header-cell *matHeaderCellDef class="copy-header">Copy</th>
          <td mat-cell *matCellDef="let order" class="copy-cell">
            <button
              mat-icon-button
              type="button"
              title="Copy to new purchase order"
              [attr.aria-label]="'Copy purchase order ' + (order.number || order.id) + ' to a new purchase order'"
              [disabled]="copyingOrderId === order.id"
              (click)="copyOrder(order, $event)">
              <mat-icon>content_copy</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="table-row clickable-row" (click)="editOrder(row)"></tr>

        <!-- No Data Row -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell no-data" [attr.colspan]="displayedColumns.length">
            <div class="no-orders">
              <mat-icon>shopping_cart</mat-icon>
              <p *ngIf="!input.value">No purchase orders found. Click "Create New Purchase Order" to add your first order.</p>
              <p *ngIf="input.value">No purchase orders match "{{ input.value }}"</p>
            </div>
          </td>
        </tr>
      </table>

      <!-- Paginator -->
      <mat-paginator 
        [pageSizeOptions]="[5, 10, 25, 50]" 
        [pageSize]="10"
        showFirstLastButtons
        aria-label="Select page of purchase orders">
      </mat-paginator>
    </div>
  </div>
</div>
